import { Chip, Typography } from '@themenu/design-system'
import { type AuthorizeProps } from 'components/Authorize/Authorize'
import * as S from './styles'

interface TitleSectionProps extends AuthorizeProps {
  title?: string
  totalItems?: number
}

export function TitleSection({
  title = '',
  totalItems = 0
}: TitleSectionProps) {
  return (
    <S.Wrapper data-testid="title-section">
      <S.TitleWrapper>
        <Typography variant="headline">{title}</Typography>
        {totalItems ? (
          <Chip
            colorSet="contrast"
            data-testid="total-items-chip"
            label={String(totalItems)}
          />
        ) : null}
      </S.TitleWrapper>
    </S.Wrapper>
  )
}
